export default "__VITE_ASSET___Ppbm0hL__"